import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "CMSWrapper.d" */ './Loadable')
);
